<template>
  <b-modal id="affected-machines-modal" ref="affected-machines-modal" hide-footer>
    <template #modal-title>
      <div>
        <h5 class="mb-0">Affected Machines</h5>
        <small class="text-muted">Email: {{ email }} / Rule Type: {{ ruleType }}</small>
      </div>
    </template>
    <b-table :items="tableItems" :fields="fields" small striped class="mb-0">
      <template #cell(serial)="data">
        <router-link :to="'/machine/' + data.item.serial" @click.native="$refs['affected-machines-modal'].hide()">
          {{ data.item.serial }}
        </router-link>
      </template>
    </b-table>
  </b-modal>
</template>

<script>

export default {
  name: 'AccessRulesModalAffectedMachines',
  data () {
    return {
      affectedMachines: null,
      fields: [
        { key: 'serial', sortable: true },
        { key: 'access_via', sortable: true },
      ],
      email: null,
      ruleType: null,
    }
  },
  computed: {
    tableItems: function () {
      const rows = []
      this.affectedMachines?.forEach(machine => {
        const dealer = machine.access_rules[0].access_machine_dealer
        const accessVia = dealer !== null ? `Dealer "${dealer}"` : `Machine Serial`
        rows.push({ serial: machine.machine_serial, access_via: accessVia })
      })
      return rows
    }
  },
  methods: {
    show (data, email, ruleType) {
      this.affectedMachines = data
      this.email = email
      this.ruleType = ruleType
      this.$refs['affected-machines-modal'].show()
    }
  }
}
</script>

<style lang="scss">
</style>
